import { useTranslation } from "react-i18next"
import { Flex } from "../../../components/flex/Flex"
import InfoBox from "../../../components/info/InfoBox"
import { InfoText } from "../../../components/info/InfoText"
import { Spacer } from "../../../components/spacer/Spacer"
import Text from "../../../components/Text"
import { theme } from "../../../styles/stitches.config"

export const CalculationLabel = () => {
  const { t } = useTranslation("microsite")

  return (
    <Flex align="center" justify="end">
      <Text type="labelsAlt">{t("sample_household_calculation")}</Text>

      <Spacer size={theme.space.s1} />

      <InfoBox inline align="end" variant="default">
        <InfoText type="textsLarge">{t("sample_household_calculation_tooltip")}</InfoText>
      </InfoBox>
    </Flex>
  )
}
